var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05295 17.105C10.9506 17.1046 12.7936 16.4694 14.2884 15.3004L18.9883 20L20.5 18.4883L15.8002 13.7888C16.9698 12.2938 17.6054 10.4505 17.6059 8.55249C17.6059 3.83686 13.7688 0 9.05295 0C4.33707 0 0.5 3.83686 0.5 8.55249C0.5 13.2681 4.33707 17.105 9.05295 17.105ZM9.05295 2.13812C12.5907 2.13812 15.4677 5.01497 15.4677 8.55249C15.4677 12.09 12.5907 14.9669 9.05295 14.9669C5.51523 14.9669 2.63824 12.09 2.63824 8.55249C2.63824 5.01497 5.51523 2.13812 9.05295 2.13812Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico-search.9c5f15002a1716332ec53e8edf4523e2.svg";
export { ForwardRef as ReactComponent };